import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { User } from '@lockton-apps/shared/interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class Users2Service {
  private readonly model = 'users';

  constructor(
    @Inject('BASE_API_URL_V2') private readonly baseUrlV2: string,
    private readonly http: HttpClient
  ) {}

  private get url(): string {
    return `${this.baseUrlV2}/${this.model}`;
  }

  brokersForAuthenticatedContact(): Observable<User[]> {
    return this.http.get<User[]>(`${this.url}/brokers`);
  }
}
